var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", [
    _c("div", { staticClass: "form-group" }, [
      _c(
        "label",
        {
          staticClass: "col-xs-3 control-label",
          staticStyle: { "padding-top": "0" },
        },
        [
          _c("input", {
            staticClass: "form-control",
            attrs: {
              type: "text",
              name: "company_item_name_" + _vm.freetext_index,
              placeholder: "項目名",
            },
            domProps: { value: _vm.bind_model.item_name },
            on: {
              input: function ($event) {
                _vm.bind_model.item_name = $event.target.value
              },
            },
          }),
        ]
      ),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-8" }, [
        _c("textarea", {
          staticClass: "form-control",
          attrs: {
            name: "company_item_contents_" + _vm.freetext_index,
            rows: "5",
            maxlength: "1000",
            placeholder: "内容を入力してください",
          },
          domProps: { value: _vm.bind_model.item_contents },
          on: {
            input: function ($event) {
              _vm.bind_model.item_contents = $event.target.value
            },
          },
        }),
        _vm._v(" "),
        _c("p", { staticClass: "form_note m-t-sm m-b-none" }, [
          _vm._v("1000文字まで"),
        ]),
      ]),
      _vm._v(" "),
      _c("div", { staticClass: "col-xs-1" }, [
        _c(
          "button",
          {
            staticClass: "btn btn-primary btn-xs",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.removeInput(
                  "#dialog_item_delete_" + _vm.freetext_index
                )
              },
            },
          },
          [
            _c("i", { staticClass: "fa fa-trash" }),
            _vm._v(" 削除\r\n            "),
          ]
        ),
      ]),
    ]),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "modal fade inmodal",
        attrs: {
          role: "dialog",
          tabindex: "-1",
          id: "dialog_item_delete_" + _vm.freetext_index,
        },
      },
      [
        _c("app-item-delete", {
          attrs: {
            freetext_index: _vm.freetext_index,
            freetext_array: _vm.freetext_array,
            modal_id: "#dialog_item_delete_" + _vm.freetext_index,
          },
        }),
      ],
      1
    ),
    _vm._v(" "),
    _c("hr", { staticClass: "hr-line-dashed" }),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }